import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Button,
  ButtonGroup,
  Card,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardBody,
} from "reactstrap";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ItemService from "../../../services/OrderingServices/ItemService";
import restroOrder from "../../../assets/orderingSystem/restrologo.png";
import useIsSmallScreen from "../../Payment Type/Component/small screen/SmallScreen";
import ResponsiveDataManagement from "../../../Components/Common/ResponsiveManagementLayout";
import StatusBadge from "../../../Components/Common/Badge";
import { useLocation } from "react-router-dom";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";

const MenuItem = () => {
  const navigate = useNavigate();
  const [itemList, setItemList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [show, setShow] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [filterOpen, setfilterOpen] = useState(false);
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("");
  const [filters, setFilters] = useState({
    namesearch: "",
    PriceMin: "",
    PriceMax: "",
    CategoryId: "",
  });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const location = useLocation();

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);
  const toggleModal = (itemId) => {
    setShow(true);
    setSelectedItemId(itemId);
  };
  const toggleModal1 = () => setShow(false);

  const customStyles = {
    headCells: { style: { fontSize: "0.92rem", fontWeight: 610 } },
    rows: { style: { fontSize: "0.9rem" } },
  };
  const [totalProducts, setTotalProducts] = useState(0);
  const [discountedProducts, setDiscountedProducts] = useState(0);
  const [hiddenProducts, setHiddenProducts] = useState(0);
  const [notHiddenProducts, setNotHiddenProducts] = useState(0);

  const isSmallScreen = useIsSmallScreen();

  // Fetch items from API
  async function fetchItemList(
    page = currentPage,
    size = pageSize,
    currentFilters = debouncedFilters
  ) {
    try {
      setLoading(true);
      const response = await ItemService.itemList({
        namesearch: currentFilters.namesearch,
        PriceMin: currentFilters.PriceMin,
        PriceMax: currentFilters.PriceMax,
        CategoryId: currentFilters.CategoryId,
        page,
        pageSize: size,
      });

      setTotalProducts(response?.summary?.totalProducts);
      setHiddenProducts(response?.summary?.hiddenProducts);
      setNotHiddenProducts(response?.summary?.notHiddenProducts);
      setDiscountedProducts(response?.summary?.discountedProducts);

      const indexedData = response?.items.map((item, index) => ({
        ...item,
        sn: (page - 1) * size + index + 1,
      }));

      setItemList(indexedData);
      setTotalRows(response?.totalCount || 0);
      setLoading(false);
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      setLoading(false);
    }
  }

  // Update filters when searchQuery changes
  useEffect(() => {
    setFilters((prev) => ({ ...prev, namesearch: searchQuery }));
  }, [searchQuery]);

  // Debounce filter changes
  useEffect(() => {
    const isFilterChanged =
      JSON.stringify(filters) !== JSON.stringify(debouncedFilters);

    if (!isFilterChanged) return;

    const timeoutId = setTimeout(() => {
      setDebouncedFilters(filters);
      setCurrentPage(1);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [filters]);

  // Fetch items when page, pageSize, or debouncedFilters change
  useEffect(() => {
    fetchItemList(currentPage, pageSize, debouncedFilters);
  }, [currentPage, pageSize, debouncedFilters]);

  useEffect(() => {
    if (location.state?.refetch) {
      fetchItemList(currentPage, pageSize, debouncedFilters);

      // clear navigation state so it doesn't refetch again
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => (currentPage - 1) * pageSize + index + 1,
      width: "75px",
    },
    {
      name: "Product Name",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img
            src={row.displayImage?.getCDNUrl() || restroOrder}
            alt={row.name}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "4px",
            }}
          />

          <Link to={`/item/detail/${row.id}`} title={row.name}>
            {row.name}
          </Link>
        </div>
      ),
      width: "20vw",
    },

    {
      name: "Category",
      selector: (row) => row.categoryName,
      sortable: true,
      width: "12vw",
    },
    {
      name: "Unit",
      selector: (row) => row.unitName || "",
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => row.price || "0",
      cell: (row) => <NumberWithCommas number={row.price} />,
      right: true,
      sortable: true,
    },
    {
      name: "IsPOS?",

      selector: (row) => row.isHidden,
      cell: (row) => (
        <StatusBadge status={row.isHidden} type="status" pill={true} />
      ),

      sortable: true,
      center: true,
    },
    // {
    //   name: "Action",
    //   cell: (row) => (
    //     <ButtonGroup className="d-flex gap-2">
    //       <Link to={`/menu-item/update/${row.id}`}>
    //         <Button color="btn btn-soft-warning" className="btn-sm ms-1">
    //           <i className="ri-edit-line" />
    //         </Button>
    //       </Link>
    //       <Button
    //         className="btn btn-soft-danger btn-sm ms-1"
    //         color="danger"
    //         onClick={() => handleDeleteClick(row.id)}
    //       >
    //         <i className="ri-delete-bin-5-line" />
    //       </Button>
    //       <Link to={`/item/detail/${row.id}`}>
    //         <Button color="btn btn-soft-success" className="btn-sm">
    //           <i className="bx bx-show" />
    //         </Button>
    //       </Link>
    //     </ButtonGroup>
    //   ),
    //   center: true,
    // },
  ];

  const stats = [
    {
      title: "Total Products",
      value: totalProducts,
      color: "#0d6efd",
      icon: "bx bx-category",
    },
    {
      title: "Active Products",
      value: notHiddenProducts,
      color: "#28a745",
      icon: "bx bx-check-circle",
    },
    {
      title: "Hidden Products",
      value: hiddenProducts,
      color: "#ffc107",
      icon: "bx bx-hide",
    },
    {
      title: "Discounted Products",
      value: discountedProducts,
      color: "#17a2b8",
      icon: "bx bx-tag",
    },
  ];

  const formik = useFormik({
    initialValues: { formfile: "" },
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append("id", selectedItemId);
        formData.append("formfile", values.formfile);
        await ItemService.updateItemImage(selectedItemId, formData);
        toast.success("Image Updated Successfully");
        fetchItemList(currentPage, pageSize, debouncedFilters);
        setShow(false);
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to update image");
      }
    },
  });

  const handleAdd = () => {
    navigate("/menu-item/create");
  };

  const handleEdit = (itemId) => {
    navigate(`/menu-item/update/${itemId.id}`);
  };

  const handleDeleteClick = (item) => {
    if (isOpenDelete) return;
    setSelectedItem(item);
    setIsOpenDelete(true);
  };

  const handleDelete = async (item) => {
    if (!item) return;

    try {
      await ItemService.deleteItem(item.id);
      toast.success("Product Deleted Successfully");
      fetchItemList(currentPage, pageSize, debouncedFilters);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to delete product");
    }
  };

  const filteredProductList = paymentStatusFilter
    ? itemList.filter((item) =>
        paymentStatusFilter === "active"
          ? item.isHidden === true
          : item.isHidden === false
      )
    : itemList;

  const paymentStatusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const handlePaymentStatusChange = (value) => {
    setPaymentStatusFilter(value);
  };
  // Handle pagination change from ResponsiveDataManagement
  const handlePaginationChange = ({ page, perPage }) => {
    setCurrentPage(page);
    setPageSize(perPage);
  };

  console.log("🚀 ~ MenuItem ~ totalRows:", totalRows);
  return (
    <>
      <ResponsiveDataManagement
        title="Products"
        pageTitle="Inventory Management"
        mobileCardTitle="Products List"
        data={filteredProductList}
        columns={columns}
        stats={stats}
        searchKeys={["name", "categoryName", "unitName", "price", "isHidden"]}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
        selectOptions={paymentStatusOptions}
        onSelect={handlePaymentStatusChange}
        selectValue={paymentStatusFilter}
        selectPlaceholder="All Status"
        loading={loading}
        emptyStateMessage="No items found"
        totalRows={totalRows}
        currentPage={currentPage}
        pageSize={pageSize}
        mobileCardRenderer={(item) => (
          <Card
            className="shadow-sm rounded-3 border-0 border-start border-4 border-primary mb-3"
            style={{ borderLeft: "4px solid #0d6efd", cursor: "pointer" }}
            onClick={() => navigate(`/item/detail/${item.id}`)}
          >
            <CardBody className="p-3">
              <div className="d-flex justify-content-between align-items-start">
                {/* Left side: Product Info */}
                <div className="flex-grow-1">
                  <h6 className="fw-bold text-primary mb-1">{item.name}</h6>
                  <p
                    className="mb-1 text-muted"
                    style={{ fontSize: "0.85rem" }}
                  >
                    Category: {item.categoryName}
                  </p>
                  <p
                    className="mb-1 text-muted"
                    style={{ fontSize: "0.85rem" }}
                  >
                    Unit: {item.unitName || "-"}
                  </p>
                  <p
                    className="mb-1 text-muted"
                    style={{ fontSize: "0.85rem" }}
                  >
                    Price: <strong>{item.price || 0}</strong>
                  </p>
                  <span
                    className={`badge ${
                      item.isHidden ? "bg-danger" : "bg-success"
                    }`}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {item.isHidden ? "Unavailable" : "Available"}
                  </span>
                </div>

                {/* Right side: Dropdown */}
                <div className="ms-2">
                  <Dropdown
                    isOpen={item.dropdownOpen || false}
                    toggle={(e) => {
                      e.stopPropagation();
                      setItemList((prev) =>
                        prev.map((i) =>
                          i.id === item.id
                            ? { ...i, dropdownOpen: !i.dropdownOpen }
                            : { ...i, dropdownOpen: false }
                        )
                      );
                    }}
                  >
                    <DropdownToggle
                      color="light"
                      className="btn-sm rounded-circle shadow-sm"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <i className="ri-more-2-fill" />
                    </DropdownToggle>
                    <DropdownMenu end>
                      <DropdownItem
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEdit(item.id);
                        }}
                      >
                        <i className="ri-edit-line me-2" /> Edit
                      </DropdownItem>
                      <DropdownItem
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(item);
                        }}
                      >
                        <i className="ri-delete-bin-line me-2" /> Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            </CardBody>
          </Card>
        )}
        onPaginationChange={handlePaginationChange}
        onSearch={setSearchQuery}
        searchTerm={searchQuery}
      />

      {/* <DeleteModal
        show={isOpenDelete}
        onCloseClick={() => setIsOpenDelete(false)}
        onDeleteClick={handleDelete}
      /> */}
    </>
  );
};

export default MenuItem;
